import * as cookie from 'cookie'

export const AUTH_COOKIES = {
  HAS_RUN_SILENT_LOGIN_STATE: 'RP_SILENT_AUTH',
  SILENT_LOGIN_RETURN_TO: 'RP_SILENT_LOGIN_RETURN_TO',
  USER_NOT_LOGGED_IN: 'RP_USER_NOT_LOGGED_IN',
  AUTH_ERROR_CODE: 'RP_AUTH_ERROR_CODE',
} as const

export const AUTH_SESSION_COOKIE_PREFIXES = ['appSession', '__session_', '__txn_']

export const serializeAuth0ClearSessionCookies = (
  cookies: Partial<Record<string, string>>
): string[] =>
  Object.keys(cookies)
    .filter((key) => AUTH_SESSION_COOKIE_PREFIXES.some((prefix) => key.startsWith(prefix)))
    .map((key) => cookie.serialize(key, '', { maxAge: 0 }))

const SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS = 300

export const serializeSilentLoginCookie = (enabled: boolean): string =>
  cookie.serialize(AUTH_COOKIES.HAS_RUN_SILENT_LOGIN_STATE, String(enabled), {
    path: '/',
    maxAge: enabled ? SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS : 0,
  })

const SILENT_LOGIN_RETURN_TO_FLAG_EXPIRY_TIME_IN_SECONDS = 60

export const serializeSilentLoginReturnToCookie = (
  returnTo: string,
  enabled: boolean,
  path = '/'
): string =>
  cookie.serialize(AUTH_COOKIES.SILENT_LOGIN_RETURN_TO, returnTo, {
    path,
    ...(enabled ? { maxAge: SILENT_LOGIN_RETURN_TO_FLAG_EXPIRY_TIME_IN_SECONDS } : { maxAge: 0 }),
  })
